





























































































































import {Component, Mixins, Watch} from 'vue-property-decorator'
import {MixinRouteMatch} from '@/components/mixins/MixinRouteMatch'
import {Explorer} from '@/model/resource/Explorer'
import FilterToggle from '@/components/FilterToggle.vue'
import FilterExplorer from '@/components/filters/FilterExplorer.vue'
import {ExplorerCollection} from '@/model/collection/ExplorerCollection'
import {ListExplorerSchema} from '@/schema/resource/Explorer/ListExplorerSchema'

@Component({
  components: {FilterToggle, FilterExplorer},
})
export default class ListExplorerView extends Mixins(MixinRouteMatch) {
  schema = new ListExplorerSchema()
  collection = new ExplorerCollection()
  filterOpen = false

  async created() {
    if (this.hasQueryParams) {
      this.updateObjectFromRoute(this.collection)
    }
    this.collection.setOrderBy('order')
    await this.$await.run('hardQuery', () => this.collection.queryAsPage())
  }

  @Watch('collection', {deep: true})
  collectionEvent() {
    this.updateRouteFromObject(this.collection)
  }

  goToPersistView(item: Explorer) {
    this.$nav.pushByName('editExplorer', item.$id)
  }

  async removeItem(item: Explorer) {
    await this.$dialog.remove(item)
    await item.removeExplorer()
    await this.collection.queryAsPage()
  }

  async changeOrder(item: Explorer, increment: number) {
    if (item.order === null) item.order = 0
    item.order += increment
    await item.changeOrder()
    this.$toast.success('system.success.persist')
    await this.$await.run('hardQuery', () => this.collection.queryAsPage())
  }
}
